import { Divider, Typography } from '@mui/material'

const Header = () => {
    return (
        <>
            <Typography variant="h3" mb="20px" pt="20px">
                Personal Todo App
            </Typography>
            <Divider />
        </>
    )
}

export default Header
